export default __webpack_public_path__ + "static/media/135044.2f75db86.svg";